<div class="container">
    <div class="container-table">
        <header class="top-header">
            <h3>Customer Enquiries</h3>
            <p>Support messages submitted by users (latest first)</p>
        </header>

        <div class="tab-head login-filter-bar">
            <div class="login-actions">
                <button class="export-button" (click)="refresh()">Refresh</button>
            </div>
        </div>

        <div class="responsive-table-wrapper">
            <table>
                <thead>
                <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Message</th>
                    <th>Submitted On</th>
                    <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="loading">
                    <td colspan="6">Loading customer enquiries...</td>
                </tr>
                <tr *ngFor="let request of requests; let i = index">
                    <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td>
                    <td>{{ request.name || '-' }}</td>
                    <td>{{ request.email || '-' }}</td>
                    <td class="message-cell">{{ request.message || '-' }}</td>
                    <td>{{ request.created_at ? (request.created_at | date: 'dd/MM/yyyy HH:mm') : '-' }}</td>
                    <td>{{ request.status || '-' }}</td>
                </tr>
                <tr *ngIf="!loading && requests.length === 0">
                    <td colspan="6">No customer enquiries found.</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="footer">
            <div class="total-records">Total Records: {{ totalRecords }}</div>
            <app-vte-pagination
                    [currentPage]="currentPage"
                    [pageSize]="recordsPerPage"
                    [totalRecords]="totalRecords"
                    [showJumpToPage]="true"
                    (pageChange)="onPageChange($event)"
                    (pageSizeChange)="onPageSizeChange($event)">
            </app-vte-pagination>
        </div>
    </div>
</div>
